module.exports = __webpack_public_path__ + "app/img/logo-sms.f853ff14.svg";